const RING_SIZE = 28
const STROKE_WIDTH = 4
const RADIUS = (RING_SIZE - STROKE_WIDTH) / 2
const CIRCUMFERENCE = 2 * Math.PI * RADIUS

export const CircularProgress = ({
  value,
  max
}: {
  value: number
  max: number
}) => {
  const progress = max > 0 ? Math.min(value / max, 1) : 0
  const offset = CIRCUMFERENCE * (1 - progress)
  return (
    <svg
      width={RING_SIZE}
      height={RING_SIZE}
      viewBox={`0 0 ${RING_SIZE} ${RING_SIZE}`}
      className='-rotate-90 shrink-0'
      aria-hidden
    >
      <circle
        cx={RING_SIZE / 2}
        cy={RING_SIZE / 2}
        r={RADIUS}
        fill='none'
        stroke='var(--mtds-color-neutral-border-subtle)'
        strokeWidth={STROKE_WIDTH}
      />
      <circle
        cx={RING_SIZE / 2}
        cy={RING_SIZE / 2}
        r={RADIUS}
        fill='none'
        stroke='var(--mtds-color-neutral-base-default)'
        strokeWidth={STROKE_WIDTH}
        strokeDasharray={CIRCUMFERENCE}
        strokeDashoffset={offset}
        strokeLinecap='round'
      />
    </svg>
  )
}
